import { isVariant, variantConfig } from './config.js';

// Client-side previews resize URLs that never round-trip through Rails, so the
// two dialects we support live here. A driver that publishes no dialect just
// leaves its URLs alone — cropImage degrades to the original URL.

function ownsUrl(driverConfig, url) {
  const hosts = (driverConfig && driverConfig.hosts) || [];
  return hosts.some((host) => host && url.indexOf(host) !== -1);
}

function qiniuVariantUrl(driverConfig, url, variant) {
  const fops = (driverConfig.styles || {})[variant];
  return fops ? `${url}?${fops}` : url;
}

function imgproxyVariantUrl(driverConfig, url, variant, options) {
  const base = String(driverConfig.imgproxy_url || '').replace(/\/$/, '');
  const opts = options[variant];
  if (!base || !opts) return url;

  const encoded = btoa(unescape(encodeURIComponent(url)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  const parts = [`rs:${opts.resizing_type}:${opts.width}:${opts.height}`];
  if (opts.quality) parts.push(`q:${opts.quality}`);
  return `${base}/insecure/${parts.join('/')}/plain/${encoded}`;
}

const DIALECTS = {
  qiniu: qiniuVariantUrl,
  minio: imgproxyVariantUrl
};

export function variantUrl(url, variant) {
  if (!url || !isVariant(variant)) return url;

  const config = variantConfig();
  const options = config.options || {};
  const driver = Object.keys(DIALECTS).find((name) => ownsUrl(config[name], url));
  if (!driver) return url;

  return DIALECTS[driver](config[driver] || {}, url, String(variant), options);
}
